import React, { Component } from "react";
import Close from "../../../../../Icons/Close";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
class ModaleSuppression extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.SupprimerFichier = this.SupprimerFichier.bind(this);
  }

  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModaleSuppression();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  SupprimerFichier = () => {
    this.setState({ styleFadeIn: false });
    this.props.onSubmitSuppression();
  };
  render() {
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin show actif"
          id="modalDelete"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form onSubmit={this.SupprimerFichier}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeModal}
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">{this.props.t('fiche_enfant.delete_fiche_title')}</h5>
                  </section>
                  <section>
                    <h5>{this.props.t('fiche_enfant.delete_fiche_confirm')}</h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                      >
                        <img
                          src="img/icon-check-white.svg"
                          class="img-fluid"
                          alt=""
                        />{" "}
                        {this.props.t('common.confirm')}
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
export default withTranslation()(ModaleSuppression);
